const styles: { container: string; title: string } = {
  container: 'flex items-center gap-4 text-xs select-none',
  title: 'font-medium text-danger text-base',
};

export default styles;
